"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var GuidePrice = function GuidePrice(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.823 63.71c-4.43-4.458-4.43-11.658 0-16.116l46.06-46.069.44-.44A2 2 0 0 1 51.736.5H93.5a2 2 0 0 1 2 2v41.774a2 2 0 0 1-.586 1.415l-46.492 46.46a11.425 11.425 0 0 1-16.17-.002L3.823 63.711zm4.958-11.174a4.43 4.43 0 0 0 .004 6.237L37.204 87.2a4.428 4.428 0 0 0 6.267 0l44.443-44.412a2 2 0 0 0 .586-1.415V9.5a2 2 0 0 0-2-2H54.636a2 2 0 0 0-1.414.586L8.781 52.536zM71 32.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm0-5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    fill: "currentColor"
  })));
};
var _default = exports.default = GuidePrice;